// Mock data for ShiftLog Protocol app

export const shifts = [
  { id: 'early', name: 'Early Shift' },
  { id: 'late', name: 'Late Shift' },
  { id: 'night', name: 'Night Shift' }
];

export const mockTasks = [
  {
    id: '1',
    text: 'Check equipment calibration in Zone A',
    completed: false,
    shift: 'early',
    createdAt: new Date().toISOString()
  },
  {
    id: '2', 
    text: 'Review safety protocols for night operations',
    completed: true,
    shift: 'early',
    createdAt: new Date().toISOString()
  }
];
